import { projectContentDefinition } from './Project';
import { ContentType } from '../ContentType';
import { IContentDefinition } from './IContentDefinition';
import { dataRoleContentDefinition } from './DataRole';
import { dataSourceContentDefinition } from './DataSource';
import { flowContentDefinition } from './Flow';
import { metricContentDefinition } from './Metric';
import { tableContentDefinition } from './Table';
import { workbookContentDefinition } from './Workbook';
import { viewContentDefinition } from './View';
import { databaseContentDefinition } from './Database';
import { lenseContentDefinition } from './Lense';
import { collectionsContentDefinition } from './Collections';
import { virtualConnectionContentDefinition } from './VirtualConnection';
import { predictiveModelContentDefinition } from './PredictiveModels';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ContentDefinitions: { [type in ContentType]: IContentDefinition<any, any> } = {
  database: databaseContentDefinition,
  datarole: dataRoleContentDefinition,
  unifieddatasource: dataSourceContentDefinition,
  virtualconnection: virtualConnectionContentDefinition,
  flow: flowContentDefinition,
  metric: metricContentDefinition,
  project: projectContentDefinition,
  table: tableContentDefinition,
  view: viewContentDefinition,
  workbook: workbookContentDefinition,
  lens: lenseContentDefinition,
  collection: collectionsContentDefinition,
  predictivemodel: predictiveModelContentDefinition
};
